export interface CreateMultiDayJobRequest {
  jobTypeId: number | null;
  customerId: number | null;
  jobSiteId: number | null;
  name: string;
  description: string;
  internalNotes?: string;
  crewNotes?: string;
  timeZone?: string;
  recurrence: {
    startDate: string; // yyyy-MM-dd
    endDate: string; // yyyy-MM-dd
    estDurationDays: number;
  };
  dispatchTimes?: {
    startTime?: string; // HH:mm
    endTime?: string; // HH:mm
    showUpTime?: string; // HH:mm
    onJobTime?: string; // HH:mm
  };
  estimates: Array<{ type: string; unit: string; value: string }>;
  options?: { idempotencyKey?: string };
}

export interface CreateMultiDayJobError {
  error: {
    code: string;
    details: Array<{ path: string; reason: string }>;
  };
}

export class CreateMultiDayJobApiError extends Error {
  public readonly payload: CreateMultiDayJobError;
  public readonly status?: number;

  constructor(message: string, payload: CreateMultiDayJobError, status?: number) {
    super(message);
    this.name = 'CreateMultiDayJobApiError';
    this.payload = payload;
    this.status = status;
  }
}

export interface RaptorJobFormSubmitInput {
  customerId: number | null;
  jobSiteId: number | null;
  jobTypeId: number | null;
  jobDescription: string;
  recurrence: 'single' | 'multi';
  startDate: Date | null;
  estimatedDurationDays: number | null;
  endDate: Date | null;
  startTime: Date | null;
  endTime: Date | null;
  showUpTime: Date | null;
  onJobTime: Date | null;
  notesForCrew: string;
  jobNotes: string;
  estimates: Array<{ id: string; metricType: string; quantity: number | null; unit: string }>;
}

export interface RaptorJobListItem {
  id: number;
  name: string;
  type: {
    id: number;
    name: string;
    description: string;
    class: string;
  };
  customer: {
    id: number;
    companyName: string;
    address: string;
    phone: string;
    email: string;
  };
  jobSite: {
    id: number;
    name: string;
    address: string;
    coordinates: {
      lat: number;
      lng: number;
    };
    phone: string;
    email: string;
  };
  status: 'scheduled' | 'completed' | 'in-progress' | 'cancelled' | 'on-hold' | 'planning';
  startDate: string;
  endDate: string;
  description: string;
  notes: string;
  timeZone: string;
  customFields: {
    id: number;
    value: string;
  }[];
}

export interface RaptorJobListQuery {
  search?: string;
  page: number;
  pageSize: number;
  sort?: {
    field: string;
    direction: 'asc' | 'desc';
  };
  filters?: {
    field: string;
    operator: string;
    value: string | number;
  }[];
}

export interface RaptorJobListResponse {
  items: RaptorJobListItem[];
  totalCount: number;
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

// Interface for getting a single RaptorJob (same structure as RaptorJobListItem)
export interface RaptorJob extends RaptorJobListItem {}

// Interface for RaptorJob query parameters (get one)
export interface RaptorJobQuery {
  id: number;
}

// Interface for RaptorJob response (get one)
export interface RaptorJobResponse {
  data: RaptorJob;
}

// Interface for cancel RaptorJob parameters
export interface RaptorJobCancelParams {
  id: number;
}

// Interface for cancel RaptorJob response
export interface RaptorJobCancelResponse {
  success: boolean;
  message?: string;
}
